import { c as _c } from "react/compiler-runtime";
import { Table as ComponentsTable } from '@systemeio/components';
import { LONG_PRESS_DRAG_CLASS_NAME } from 'shared/hooks/use-drag-sensors';
import { twMerge } from 'tailwind-merge';
import { resolveRowId } from '../utils';
import { getRowClassName, getRowClickHandler, getRowTestAttributes } from '../utils/table-row-helpers';
import { useSortableRow } from '../utils/use-sortable-row';
import { ColumnLoaderRows } from './column-loader-rows';
import type { TabletRowProps, TabletViewProps } from './view-props';
function TabletRow(t0) {
  const $ = _c(19);
  const {
    row,
    renderRow,
    testAttributePostfix,
    isSortable,
    rowClassName,
    getRowId,
    onRowClick
  } = t0;
  const rowId = resolveRowId({
    row,
    getRowId
  });
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    style
  } = useSortableRow({
    rowId,
    isSortable
  });
  const resolvedRowClassName = getRowClassName(row, rowClassName);
  let t1;
  if ($[0] !== onRowClick || $[1] !== row) {
    t1 = getRowClickHandler(row, onRowClick);
    $[0] = onRowClick;
    $[1] = row;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rowClickHandler = t1;
  const testAttributes = getRowTestAttributes(rowId, testAttributePostfix);
  const t2 = ComponentsTable;
  const t3 = twMerge(isDragging && "border-border-accent border-dashed", isSortable ? "cursor-grab" : onRowClick ? "cursor-pointer" : "cursor-auto", isSortable && LONG_PRESS_DRAG_CLASS_NAME, resolvedRowClassName);
  let t4;
  if ($[3] !== renderRow || $[4] !== row) {
    t4 = renderRow?.(row);
    $[3] = renderRow;
    $[4] = row;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <ComponentsTable.Cell>{t4}</ComponentsTable.Cell>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== attributes || $[9] !== listeners || $[10] !== rowClickHandler || $[11] !== rowId || $[12] !== setNodeRef || $[13] !== style || $[14] !== t2.Row || $[15] !== t3 || $[16] !== t5 || $[17] !== testAttributes) {
    t6 = <t2.Row ref={setNodeRef} id={rowId} style={style} onClick={rowClickHandler} className={t3} {...attributes} {...listeners} {...testAttributes}>{t5}</t2.Row>;
    $[8] = attributes;
    $[9] = listeners;
    $[10] = rowClickHandler;
    $[11] = rowId;
    $[12] = setNodeRef;
    $[13] = style;
    $[14] = t2.Row;
    $[15] = t3;
    $[16] = t5;
    $[17] = testAttributes;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}
export function TabletView(t0) {
  const $ = _c(2);
  let t1;
  if ($[0] !== t0) {
    const {
      selectionProps,
      data,
      limiter,
      visibleColumns,
      totalWidth,
      renderRow,
      ...rowProps
    } = t0;
    t1 = <ComponentsTable.Root className="table-fixed" {...selectionProps}>{data === undefined ? <ColumnLoaderRows limiter={limiter} visibleColumns={visibleColumns} totalWidth={totalWidth} /> : <ComponentsTable.Body>{data.items.map(row => <TabletRow key={resolveRowId({
          row,
          getRowId: rowProps.getRowId
        })} {...rowProps} row={row} renderRow={renderRow} />)}</ComponentsTable.Body>}</ComponentsTable.Root>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}